import LabelProvider from "core/components/label/LabelProvider";

export default LabelProvider.create({

	userName: {
		k: "userRegistration.userName",
		v: "Username"
	},

	
});



// WEBPACK FOOTER //
// ./src/panels/userRegistration/UserRegistration.labels.tsx